var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEta = function SvgEta(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M18 20v24h28V20H18zm0-2h28a2 2 0 0 1 2 2v24a2 2 0 0 1-2 2H18a2 2 0 0 1-2-2V20a2 2 0 0 1 2-2zm4 8a1 1 0 0 1 0-2h20a1 1 0 0 1 0 2H22zm7.974 3.7h.056v10.472h-2.058v-7.028l-1.512.798-.84-1.89 4.354-2.352zm2.016.182h5.768v1.848h-3.696v2.114c.27-.121.57-.182.896-.182 1.008 0 1.83.29 2.464.868.635.579.952 1.419.952 2.52 0 .97-.313 1.764-.938 2.38-.625.616-1.46.924-2.506.924-1.773 0-2.921-.77-3.444-2.31l1.75-.84c.177.868.695 1.302 1.554 1.302.439 0 .798-.145 1.078-.434.28-.29.42-.663.42-1.12 0-.457-.14-.828-.42-1.113-.28-.285-.644-.427-1.092-.427-.55 0-1.013.173-1.386.518l-1.4-.63v-5.418z"
  })));
};
export default SvgEta;